// removed by extract-text-webpack-plugin
module.exports = {"GetStartedCards":"GetStartedCards---3MSpy","GetStarted":"GetStarted---1NsZh","GetStartedCards__Icon":"GetStartedCards__Icon---atCb5"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Integration/style.styl
// module id = R2Sm
// module chunks = 89